<div class="row step-header">
  <div class="col col-100">
    <h3>Enter your billing details</h3>
    <p>After your promotional period, Starry Internet is just ${{plan_amount}} a month. Enter your credit card and billing address below.</p>
    <p class="step-error js-paymentError">
      <!-- Stripe Errors will be appended here -->
    </p>
  </div>
</div>

<div class="row">
  <div class="col col-100 tablet--col-60 billing-main">
    <div class="card-layout no-border text-dark">
      <div class="row">
        <div class="col col-100">
          <h5 class="small mb0">1. Card info</h5>
        </div>
        <div class="col col-100 pt0 pb0">
          <div id="payment-request-button" class="hide-on-payment-api-success"></div>
          <div id="payment-request-text" class="hide-on-payment-api-success">
            <span>Or enter card details</span>
          </div>
          <div id="payment-request-success" class="show-on-payment-api-success">
            <div class="icon">
              <svg width="84px" height="84px" viewBox="0 0 84 84" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <circle class="border" cx="42" cy="42" r="40" stroke-linecap="round" stroke-width="4" stroke="#000" fill="none"></circle>
                <path class="checkmark" stroke-linecap="round" stroke-linejoin="round" d="M23.375 42.5488281 36.8840688 56.0578969 64.891932 28.0500338" stroke-width="4" stroke="#000" fill="none"></path>
              </svg>
            </div>
            <span class="message">Your payment information has been saved</span>
          </div>
        </div>
        <div class="col col-100 hide-on-payment-api-success">
          <label for="cc_number_element">Card Number*</label>
          <div class="cc_input" id="cc_number_element"></div>
          <div class="error-message"></div>
        </div>
      </div>

      <div class="row">
        <div class="col col-100 desktop--col-50 hide-on-payment-api-success">
          <label for="cc_expiry_element">Expiration Date*</label>
          <div class="cc_input" id="cc_expiry_element"></div>
          <div class="error-message"></div>
        </div>
        <div class="col col-100 desktop--col-50 hide-on-payment-api-success">
          <label for="cc_cvc_element">CVC*</label>
          <div class="cc_input" id="cc_cvc_element"></div>
          <div class="error-message"></div>
        </div>
      </div>

      <div class="row mb0 mt0 pt0 pb0">
        <div class="col col-100">
          <h5 class="small">2. Billing Info</h5>
          <label class="custom_checkbox" for="same_billing">
            <input type="checkbox" id="same_billing" name="billing_same_as_service" {{ checked billing_same_as_service true }}>
            Billing address is same as service address
            <span class="checkbox_control"></span>
          </label>
        </div>
      </div>
      <div class="js-billingAddress billing-address"></div>
      <div class="row">
        <div class="col col-100">
          <h5 class="small">3. Agree to Terms</h5>
          <label class="custom_checkbox agree-to-terms-label" for="agree_to_terms">
            <input type="checkbox" id="agree_to_terms" name="agree_to_terms" {{ checked agree_to_terms true }}>
              I have reviewed the <a href="https://starry.com/legal/privacy" target="_blank">Starry Privacy Notice</a>,
              and agree to the
              <a href="https://starry.com/legal/internet-terms" target="_blank">Starry Terms of Use</a>.
            <span class="checkbox_control"></span>
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class="col col-100 tablet--col-40 payment-sidebar js-paymentSidebar">
    {{{ sidebarMarkup }}}
  </div>
</div>
